<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/lZe5P2/tc-custom/9780226160702.jpg?1724853611608" alt="This image is the cover for the book Black Chicago"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Black Chicago
      </h1>
      <p class="bookDescription body article font2">
        <p>Allan Spear explores here the history of a major Negro community during a crucial thirty-year period when a relatively fluid patter of race relations gave way to a rigid system of segregation and discrimination. This is the first historical study of the ghetto made famous by the sociological classics of St. Clair Drake, E. Franklin Frazier, and others—by the novels of Richard Wright, and by countless blues songs. It was this ghetto that Martin Luther King, Jr., chose to focus on when he turned attention to the racial injustices of the North. Spear, by his objective treatment of the results of white racism, gives an effective, timely reminder of the serious urban problems that are the legacy of prejudice.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Allan H. Spear
      </h2>
      
      <p class="authorDescription body article">Please fill in author biography</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1c41f198